module.exports = __webpack_public_path__ + "img/7.b39ec6fc.png";